export function parseExcelPaste(content: string) {

  const rows = content
    .trim()
    .split(/\r?\n/)
    .map(row => row.trim())
    .filter(row => row.length > 0);

  if (rows.length === 0) {
    return [];
  }

  return rows
    .filter(row => {

      const header =
        row.toLowerCase().replace(/\s/g, "");

      return !header.startsWith(
        "email;licence;nom;"
      );
    })
    .map(row => {

      const separator =
        row.includes("\t")
          ? "\t"
          : row.includes(";")
            ? ";"
            : ",";

      const cols = row
        .split(separator)
        .map(col => col.trim());

      return {
        email: cols[0] ?? "",
        licence: cols[1] ?? "",
        lastName: cols[2] ?? "",
        firstName: cols[3] ?? "",
        gender: cols[4] ?? "",
        nationality: cols[5] ?? "",
        birthDate: cols[6] ?? "",
        category: cols[7] ?? "",
        clubNumber: cols[8] ?? "",
        clubName: cols[9] ?? "",
      };
    });
}